import { Box, Button, Checkbox, FormControlLabel, Grid, TextField, Typography, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconTelegram from '../../../components/Icons/IconTelegram';
import StyledSubcription from './styles';

const Subscriptions = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const label1 = t('contact-content');
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <StyledSubcription>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'column', lg: 'row', xl: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          // minHeight: '100vh',
          backgroundColor: '#F0EEEF',
          color: theme.palette.background.secondary,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 8,
          paddingBottom: 10,
          [theme.breakpoints.down('lg')]: {
            px: 1,
            py: 1,
          },
        }}
      >
        <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 15, xl: 15 }}>
          {/* Left Content */}
          <Grid item xs={12} md={12} lg={6} xl={6}>
            <Box
              justifyContent={'center'}
              sx={{
                padding: '130px 30px 0 50px',
                [theme.breakpoints.down('lg')]: {
                  padding: '50px 30px 0 30px',
                }
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  mb: 2,
                  wordWrap: 'break-word',
                  fontWeight: 700,
                  fontSize: '47.81px',
                  color: '#000000',
                  lineHeight: '57.06px',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '40px',
                    lineHeight: '47.73px',
                    textAlign: 'center',
                    display: 'none',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                    },
                  }}
                // viewport={{ once: true }}
                >
                  {t('contact-title')}
                </motion.div>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  mb: 2,
                  lineHeight: '44px',
                  wordWrap: 'break-word',
                  fontWeight: 700,
                  fontSize: '47.81px',
                  color: '#000000',
                  lineHeight: '48px',
                  display: 'none',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '40px',
                    lineHeight: '47.73px',
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    mb: 3,
                  },
                }}
              >
                {t('contact-title')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  // wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                  fontSize: '17.462px',
                  color: '#6C6964',
                  lineHeight: '20.84px',
                  mb: 2.5,
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '18px',
                    lineHeight: '23.4px',
                    textAlign: 'center',
                    display: 'none',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  {parse(label1)}
                </motion.div>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  // wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'unset' : '600',
                  fontSize: '17.462px',
                  color: '#6C6964',
                  lineHeight: '25.6px',
                  display: 'none',
                  mb: 2.5,
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '18px',
                    lineHeight: '23.4px',
                    textAlign: 'center',
                    display: 'block',
                    justifyContent: 'center',
                  },
                }}
              >
                {parse(label1)}
              </Typography>
              {isMobile ? (
                <Box textAlign={'center'} display={'flex'} justifyContent={'center'}>
                  <IconTelegram />
                </Box>
              ) : (
                <Box textAlign={'left'} display={'flex'} justifyContent={'left'}>
                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 100,
                    }}
                    whileInView={{
                      opacity: 1,
                      y: 0, // Slide in to its original position
                      transition: {
                        duration: 1, // Animation duration
                        delay: 1.3,
                      },
                    }}
                  // viewport={{ once: true }}
                  >
                    <IconTelegram />
                  </motion.div>
                </Box>
              )}
            </Box>
          </Grid>
          {/* Right Content */}
          <Grid item xs={12} md={12} lg={6} xl={6}
            sx={{
              [theme.breakpoints.down('lg')]: {
                px: 2,
              },
            }}
          >
            <Grid
            >
              <Box
                sx={{
                  flex: 1,
                  display: 'inline',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 3,
                }}
              >
                <Typography
                  sx={{
                    color: '#000000',
                    fontSize: '16px',
                    fontWeight: 700,
                    marginBottom: '15px',
                  }}
                >
                  {t('contact-label-one')}
                </Typography>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  sx={{
                    border: '1px solid #D7D7D7',
                    borderRadius: '4px',
                    borderColor: '#D7D7D7',
                    marginBottom: '25px',
                    width: '508px',
                    height: '52.39px',
                    color: '#000000 !important',
                    [theme.breakpoints.down('lg')]: {
                      width: '100%',
                      height: '50px',
                      border: '1px solid #B3B3B3',
                      borderRadius: '8px',
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid>
              <Box
                sx={{
                  flex: 1,
                  display: 'inline',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    color: '#000000',
                    fontSize: '16px',
                    fontWeight: 700,
                    marginBottom: '15px',
                  }}
                >
                  {t('contact-label-two')}*
                </Typography>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  sx={{
                    border: '1px solid #D7D7D7',
                    borderRadius: '4px',
                    borderColor: '#D7D7D7',
                    marginBottom: '15px',
                    width: '508px',
                    height: '52.39px',
                    color: '#000000 !important',
                    [theme.breakpoints.down('lg')]: {
                      width: '100%',
                      height: '50px',
                      border: '1px solid #B3B3B3',
                      borderRadius: '8px',
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid>
              <Box
                sx={{
                  flex: 1,
                  display: 'inline',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    color: '#000000',
                    fontSize: '16px',
                    fontWeight: 700,
                    marginBottom: '15px',
                  }}
                >
                  {t('contact-label-three')}
                </Typography>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  sx={{
                    border: '1px solid #D7D7D7',
                    borderRadius: '4px',
                    borderColor: '#D7D7D7',
                    marginBottom: '25px',
                    width: '508px',
                    height: '70.78px',
                    color: '#000000 !important',
                    [theme.breakpoints.down('lg')]: {
                      width: '100%',
                      height: '50px',
                      border: '1px solid #B3B3B3',
                      borderRadius: '8px',
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid>
              <Box
                sx={{
                  flex: 1,
                  display: 'inline',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    color: '##6C6964',
                    fontSize: '12.7px',
                    fontWeight: 400,
                    marginBottom: '15px',
                    lineHeight: '15.16px',
                    [theme.breakpoints.down('lg')]: {
                      color: '#6C6964',
                      fontWeight: 500,
                      lineHeight: '18.2px',
                      fontSize: '14px',
                    },
                  }}
                >
                  {parse(t('contact-label-four'))}
                </Typography>
                <FormControlLabel
                  control={<Checkbox />}
                  label={t('contact-label-five')}
                  sx={{
                    color: '#6C6964',
                    fontSize: '18px',
                    fontWeight: 400,
                    // px: 1,
                    borderRadius: 'unset',
                    '& .MuiFormControlLabel-label': {
                      paddingLeft: '15px',
                    },
                    '& .MuiCheckbox-root': {
                      color: '#B3B3B3',
                    },
                    [theme.breakpoints.down('lg')]: {
                      color: '#6C6964',
                      fontWeight: 400,
                      fontSize: '18px',
                      mt: 2,
                    },
                  }}
                />
                <Box
                  sx={{
                    [theme.breakpoints.down('lg')]: {
                      display: 'flex',
                      justifyContent: 'center',
                    },
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      color: '#000000',
                      backgroundColor: '#00FF00',
                      // borderColor: '#00AA2F',
                      borderRadius: '4px',
                      width: localStorage.getItem('i18nextLng') === 'en-US' ? '135.03px' : '125.03px',
                      height: '65.03px',
                      // marginRight: '30px',
                      marginTop: 4,
                      fontSize: '20px',
                      fontWeight: 600,
                      boxShadow: 'unset',
                      [theme.breakpoints.down('lg')]: {
                        // width: '100%',
                        height: '50px',
                        mb: 3,
                        marginTop: 4,
                        boxShadow: '1px 10px 10px 0px rgba(0, 0, 0, 0.25)',
                      },
                    }}
                  >
                    {t('contact-button')}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledSubcription>
  );
};

export default Subscriptions;
